import { createTheme } from '@material-ui/core/styles';
import breakpoints from './breakpoints';

const Theme = createTheme({
  breakpoints,
  typography: {
    base: {
      regular: 'Proxima, Roboto, Arial, sans-serif',
      bold: 'ProximaBold, Roboto, Arial, sans-serif',
      light: 'ProximaLight, Roboto, Arial, sans-serif',
      semiBold: 'ProximaSemiBold, Roboto, Arial, sans-serif',
    },
    display: {
      regular: 'Kapra',
    },
    size: {
      0: '0.75rem', // 12px
      0.5: '0.875rem', // 14px
      1: '0.875rem', // 14px
      1.5: '1rem', // 16px
      2: '1rem', // 16px
      3: '1.125rem', // 18px
      4: '1.25rem', // 20px
      5: '1.375rem', // 22px
      6: '1.5rem', // 24px
      6.5: '1.625rem', // 26px
      7: '1.875rem', // 30px
      8: '1.875rem', // 34px
      9: '2.25rem', // 36px
      10: '2.5rem', // 40px
      11: '3rem', // 48px
      12: '4rem', // 64px
      13: '4.5rem', // 72px
    },
  },
  palette: {
    // current palette
    primary: {
      main: '#061556',
      light: '#005EDC',
      dark: '#001871',
    },
    secondary: {
      // used for outlind buttons
      main: '#005EDC',
      dark: '#0022BD',
    },
    error: {
      main: '#ED1D24',
      warning: '#FF6B00',
      text: '#A8151A',
    },
    warning: {
      main: '#AF6620',
    },
    divider: '#E5E5E5', // replace for gray[200]
    shadow: '#06155626',
    background: '#E8E9EB',
    darkBackground: '#CDCFD1',
    white: '#FFFFFF',
    green: '#05A56B',

    blackScale: {
      opacity: '#00000061',
    },
    shadowOpacity: '#06155626',
    blueScale: {
      main: '#0173BC',
      light: '#0AAADC',
      aqua: '#4EC2B9',
    },
    // new palette definition
    gray: {
      50: '#F7F8F9', // lightest background variation
      100: '#F5F5F5', // very light background variation
      150: '#EFF0F1', // background variation
      200: '#E5E5E5', // separator or disabled background
      250: '#CCCED8', // separator
      300: '#BBBBBB', // middle light tone
      400: '#7B7B7B', // disabled text
      500: '#787A7E', // main text color
      600: '#9F9F9F', // placeholder text color
      650: '#626366', // gray 1 for contrast (shifted down)
      700: '#4A4A4A', // dark text or icon color (shifted down)
      750: '#535455',
      800: '#151617', // neutral darkest (shifted down)
      850: '#8E8F90', // input border
      900: '#535353', // low middle light tone
    },

    text: {
      brand: '#061556',
      body: '#151617',
    },
    surface: {
      brand: '#E5E7F0',
    },
    border: {
      divider: '#D3D4D5',
    },
  },
  shadows: [
    'none',
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-1
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-2
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-3
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-4
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-5
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-6
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-7
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-8
  ],

  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: '#FFFFFF',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderColor: '#8E8F90',
        // Hover state
        '&:hover $notchedOutline': {
          borderColor: '#8E8F90',
        },
        '&:hover': {
          borderColor: '#8E8F90',
        },
      },
      // Default State
      notchedOutline: {
        borderColor: '#8E8F90',
      },
    },
  },
});

Theme.typography.h1 = {
  color: Theme.palette.text.brand,
  fontSize: Theme.typography.size[7],
  fontFamily: Theme.typography.base.semiBold,
  [Theme.breakpoints.up('md')]: {
    fontSize: Theme.typography.size[9],
  },
};
Theme.typography.subtitle1 = {
  color: Theme.palette.text.brand,
  fontSize: Theme.typography.size[6.5],
  fontFamily: Theme.typography.base.regular,
  fontWeight: 'normal',
  [Theme.breakpoints.up('md')]: {
    fontSize: Theme.typography.size[7],
  },
};
Theme.typography.h3 = {
  color: Theme.palette.error.main,
  fontSize: Theme.typography.size[6],
};
export default Theme;
